// import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'collab.my',
    path: 'project/:c0101_id/investor',
    name: 'ProjectInvestorList',
    component: () => import('./PgProjectInvestorList'),
    meta: {
      title: '資助者列表'
    }
  }
]
